import React, {  useState } from 'react';
import {
  Col,
  Input,
  Row,
  Select,
  Modal,
  Form,
  Spin,
  InputNumber,
  notification,
} from 'antd';

import { PageModalProps } from 'components/Page';
import { useQuery } from 'react-query';
import { createScoringFile, getScoringGridListByCriteria } from 'services/scoring';
import Button from 'components/Button';
import FormInput from 'components/FormInput';
import Title from 'components/Title';
import ParListSelect from 'components/ParListSelect';
import SaveButton from 'components/SaveButton';
import { FormInstance } from 'antd/lib/form';


type AddFinStatementProps = PageModalProps & {
  objectid: number;
  object: string;
  tpname?:string;
  tpreference?:string
  refetch: () => void;
  isFetching:any
  form: FormInstance;

};

const AddFinStatement = (props: AddFinStatementProps) => {
  const {
    form,
    tpname,
    tpreference,
    object,
    objectid,
    visible = false,
    onCancel,
    refetch,
    isFetching
  } = props;

  const { data: scoringGrid } = useQuery(
    ['getScoringGridListByCriteria', { objectid, object }],
    () =>
      getScoringGridListByCriteria({
        objectid: objectid!,
        objecttype: object!,
      }).then((res) => res.list || []),
    {
      enabled: !!objectid && !!object,
    }
  );
const [state,setState] = useState({
    scogridid:0,
    referenceyear:"",
    currcode:localStorage.getItem('currcode') ?? '',
    requestedamount:0,
})

const create = (
  scogridid: number,
  referenceyear: string,
  currcode: string,
  requestedamount: number
) => {
scogridid === 0
  ? notification.error({message:"Invalid scogridid: 0 is not allowed."})
  :createScoringFile({
    objectid: objectid!,
    objecttype: 'THIRDPARTY',
    objectreference: '',
    scogridid: scogridid,
    tpid: objectid!,
    tprole: 'CLIENT',
    tpname: tpname ?? '',
    tpreference: tpreference ?? '',
    referenceyear: referenceyear,
    currcode: currcode,
    requestedamount: requestedamount,
  }).then((response) => {
    if (response.code === '200') {
      notification.success({
        message: response.message,
      });
      refetch();
      onCancel&& onCancel()
      setState({
        scogridid:0,
        referenceyear:"",
        currcode:localStorage.getItem('currcode') ?? '',
        requestedamount:0,
    })
    }
  });
};


  return (
    (<Modal
      open={visible}
      onCancel={onCancel}
      width={800}
      title={[<Title comcode="Create Financial Statement" key="" level={5}/>]}
      footer={[<Button key="cancel" comcode="cancel" onClick={onCancel} />]}
    >
      <Spin spinning={isFetching}>
      <Form>
    
     <Row>
         <FormInput col xs={12} name="scogridid" rules={[{ required: true }]}>
         
       <Select style={{ width: '100%' }} onChange={(e)=>state.scogridid=Number(e)} > 
         {scoringGrid?.map((data) => (
           <Select.Option key={data.scoid} value={data.scoid}>
             {data.scolabel}
           </Select.Option>
         ))}
       </Select>
       </FormInput>
       <FormInput col xs={12} name="currcode">
         
        <ParListSelect parcode='CURRENCY' onChange={(e)=>state.currcode=e}/>
         </FormInput>
      
       </Row>
     <Row>
       <FormInput col xs={12} name="referenceyear">
       <Input maxLength={4} onChange={(e)=>state.referenceyear=e.target.value} /> 
       </FormInput>
       <FormInput col xs={12} name="requestedamount" >
       <InputNumber onChange={(e)=>state.requestedamount=Number(e)}/> 
       </FormInput>
     </Row>
     <Row>
       <Col span={24}>
         <SaveButton
           size="large"
            onClick={()=>{create(state?.scogridid,state?.referenceyear,state?.currcode,state?.requestedamount);refetch()}}
            comcode='create'
            
         />
       </Col>
       </Row>
    
     </Form></Spin>
    </Modal>)
  );
};

export default AddFinStatement;
